<ng-container *ngFor="let action of grid.getSetting('actions.custom')">
    <ion-button size="small" [color]="action.color || 'primary'"  (click)="onCustom(action, $event)">
        <ion-icon *ngIf="action.name === 'edit'" slot="icon-only" name="create"></ion-icon>
        <ion-icon *ngIf="action.name === 'delete'" slot="icon-only" name="trash"></ion-icon>
        <ion-icon *ngIf="action.name === 'takeOverData'" slot="icon-only" name="person-add"></ion-icon>
        <ion-icon *ngIf="action.name === 'takeover'" slot="icon-only" name="copy"></ion-icon>
        <ion-icon *ngIf="action.name === 'print'" slot="icon-only" name="print"></ion-icon>
    </ion-button>
</ng-container>
